import { makeSlug } from "@/utils/utils"
import { AgenceArticle } from "./agenceArticle.types"

export const getArticleUrl = (
  type: AgenceArticle['type'],
  slug: AgenceArticle['slug'],
) => {

  return `/blog/${makeSlug(type)}/${slug}`
}

export const serviceMapping = {
  vente: "Vente",
  achat: "Achat",
  location: "Location",
  estimation: "Estimation",
  programme_neuf: "Programmes neufs",
  investissement: "Investissement",
  gestion_locative: "Gestion locative",
  agence_immobilier: "Agence immobilière",
  conseiller_immobilier: "Conseiller immobilier",
  groupe_immobilier: "Groupe immobilier"
} as const

export const typeMapping = {
  article: "Article",
  actualite: "Actualité",
  guide: "Guide",
} as const